export default __webpack_public_path__ + "static/media/brain.3b0cbc7c.svg";